import { TrashLight } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import type { FactTrajectoryEntity } from '../../service/entities';

import styles from './trajectory-list-sidebar.module.scss';

type Props = {
  trajectory: FactTrajectoryEntity;
  selected: boolean;
  disabled?: boolean;
  canDelete?: boolean;
  onSelect: (trajectoryId: number) => void;
  onDelete?: (trajectoryId: number) => void;
};

export const TrajectoryListItem = observer(function TrajectoryListItem({
  trajectory,
  selected,
  disabled = false,
  canDelete = false,
  onSelect,
  onDelete,
}: Props) {
  const { t } = useTranslation();
  const active = Boolean(trajectory.data.active);
  const title = trajectory.data.citation.title || t('ListSidebar.untitled');

  const handleDeleteClick = (event: MouseEvent) => {
    event.stopPropagation();
    onDelete?.(trajectory.id);
  };

  return (
    <div className={clsx(styles.listItemRow, selected && styles.listItemSelected, disabled && styles.listItemDisabled)}>
      <Button
        type="button"
        variant="flat"
        size="s"
        disabled={disabled}
        className={styles.listItem}
        onClick={() => onSelect(trajectory.id)}
      >
        <span className={styles.listItemTitle}>{title}</span>
        {active && <span className={styles.listItemBadge}>{t('ListSidebar.active')}</span>}
      </Button>
      {canDelete && (
        <Button
          type="button"
          variant="flat"
          size="s"
          className={styles.deleteButton}
          icon={<TrashLight />}
          disabled={disabled}
          onClick={handleDeleteClick}
        />
      )}
    </div>
  );
});
